import { HTMLProps, useEffect, useState } from 'react'
import { ButtonStyle, Class, Product, TaxType } from 'ts/types'
import useAuthStore from 'store/auth';
import useModalForm from 'hooks/useModalForm'
import useFetchSafe from 'hooks/useFetchSafe'
import GetUrls from 'ts/enums/Url'
import useModalStore from 'store/modal'
import { CheckBoxToggle, Input, Select } from 'components/ui'
import { ButtonStyleItem } from 'components'
import { SpinnerIcon } from 'components/svg'

const ProductAddPage = () => {
  const Url = GetUrls();
  const params = useModalStore((state) => state.params) as Product
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form
  const [imagePreview, setImagePreview] = useState<string | null>();
  const traders = useAuthStore((state) => state.user.traders);

  const [ classOptions, setClassOptions ] = useState<HTMLProps<HTMLOptionElement>[]>([]);
  const [ subclassOptions, setSubclassOptions ] = useState<HTMLProps<HTMLOptionElement>[]>([]);
  const [ taxOptions, setTaxOptions ] = useState<HTMLProps<HTMLOptionElement>[]>([]);
  const [ priceLevelOptions, setPriceLevelOptions ] = useState<HTMLProps<HTMLOptionElement>[]>([]);
  const [ buttonStyleOptions, setButtonStyleOptions ] = useState<HTMLProps<HTMLOptionElement>[]>([]);
  const productTypeOptions = [
    { value: "1", children: "Regular Product" },
    { value: "2", children: "Gift Card" },
    { value: "3", children: "Cash Out" }
  ];

  const [isLoading, setLoading] = useState<boolean>(true);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isActivePrice, setIsOpenPrice] = useState<boolean>(false);
  const [currentClass, setCurrentClass] = useState<string>("");
  const [currentPrice, setCurrentPrice] = useState<string>("");
  const [priceMax, setPriceMax] = useState<string>("");
  const [priceMin, setPriceMin] = useState<string>("");
  const [currentButtonStyle , setButtonStyle] = useState<string>();
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  // ~ FETCH DATA ~
  const { data: ClassOpt, isLoading: classLoading } = useFetchSafe<Class>(Url.getClass);
  const { data: SubClassOpt, isLoading: subClassLoading } = useFetchSafe(Url.getSubclass);
  const { data: TaxOpt } = useFetchSafe(Url.getTax);
  const { data: PriceLevelOpt } = useFetchSafe(Url.getPriceLevel);
  const { data: ButtonStyleOpt} = useFetchSafe<ButtonStyle>(Url.getButtonStyle);
  const { data: TaxTypeData,isLoading: taxLoading  } = useFetchSafe<TaxType>(`${Url.productTaxType}/${params ? params.productId : ''}`);
  const { data: ProductPriceData, isLoading: priceLoading } = useFetchSafe<{ price: string, openPriceMin: string, openPriceMax: string, productPriceLevelId: number }>(`${Url.getProductPriceLevel}/${params ? params.productId : ''}`);

  const handleToggleActive = (isChecked: boolean) => {setIsActive(isChecked);}
  const handleToggleOpenPrice = (isChecked: boolean) => {setIsOpenPrice(isChecked);}
  const handleClassChange = (value:string) => {setCurrentClass(value);}
  const handleButtonChange = (value:string) => {
    setButtonStyle(value);
    setValue('buttonStyleId', Number(value))
  }

  const mapOptions = (data: any[], idKey: string, nameKey: string) => {
    return data.map(dataMap => ({
      value: dataMap[idKey].toString(),
      children: dataMap[nameKey]
    }));
  };

  useEffect(() => {
    if(params) {
      setValue('productId', params.productId);
      setValue('thorProductId', params.thorProductId);
      setValue('traderId', params.traderId);
      setValue('sku', params.sku);
      setIsActive(params.flActive);
      setIsOpenPrice(params.flOpenPrice);
      setSelectedIds(params.traderId);
    }
  }, [])

  useEffect(() => {
    if (ClassOpt && SubClassOpt && PriceLevelOpt && TaxOpt && ButtonStyleOpt) {
      setTaxOptions(mapOptions(TaxOpt, 'taxTypeId', 'name'));
      setPriceLevelOptions(mapOptions(PriceLevelOpt, 'productPriceLevelId', 'name'));
      setClassOptions(mapOptions(ClassOpt, 'classId', 'name'));
      let subClassOpts = SubClassOpt.map((dataMap: any) => ({
        value: dataMap.subclassId.toString(),
        children: dataMap.name,
        classId: dataMap.classId
      }))
      setSubclassOptions(subClassOpts)
      setButtonStyleOptions(mapOptions(ButtonStyleOpt, 'buttonStyleId', 'name'));
    }
  }, [ClassOpt, SubClassOpt, TaxOpt, PriceLevelOpt, ButtonStyleOpt]);
  
  useEffect(() => {
    if (params && SubClassOpt && ClassOpt) {
      const defaultClass = (SubClassOpt.find(({ subclassId }: any) => subclassId === params.subclassId) as { classId: any })?.classId;
      setCurrentClass(defaultClass);
    }
  }, [params, SubClassOpt, ClassOpt]);
  
  useEffect(() => {
    if ([taxOptions, priceLevelOptions, subclassOptions, taxOptions, buttonStyleOptions].every(option => option && option.length > 0)) {
      setLoading(false);
    }
  }, [subclassOptions])
  
  useEffect(() => {
    let subClassOpts = SubClassOpt.map((dataMap:any) => ({
      value: dataMap.subclassId.toString(),
      children: dataMap.name,
      classId: dataMap.classId
    }))
    let filter = subClassOpts.filter(({ classId }) => classId === Number(currentClass))
    setSubclassOptions(filter);
  }, [currentClass]);
  
  useEffect(() => {
    setCurrentPrice(ProductPriceData[0]?.price)
    setPriceMax(ProductPriceData[0]?.openPriceMax)
    setPriceMin(ProductPriceData[0]?.openPriceMin)
    setValue('productPriceLevelId', ProductPriceData[0]?.productPriceLevelId);
  }, [ProductPriceData]);
  
  useEffect(() => {
    if(TaxTypeData[0]){
      setValue("productTaxId", TaxTypeData[0]?.productTaxId)
    }
  }, [TaxTypeData, taxOptions]);

  useEffect(() => {
    if (buttonStyleOptions.length !== 0) {
      const defaultButtonStyleId = ButtonStyleOpt[0]?.buttonStyleId.toString();
      let selectedButtonStyleId = defaultButtonStyleId;
      if(params?.buttonStyleId){
        const foundButton = ButtonStyleOpt.find(option => option.buttonStyleId === params.buttonStyleId);
        if (foundButton) {
          selectedButtonStyleId = params.buttonStyleId.toString();
        }
      }
      setButtonStyle(selectedButtonStyleId);
      setValue('buttonStyleId', Number(selectedButtonStyleId));
    }
  }, [buttonStyleOptions]);
    
  const handleCheckboxChange = (id: number) => {
    setSelectedIds(prev => {
      const updatedIds = prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id];
      setValue('traderId', updatedIds);  // Update form state with selected IDs
      return updatedIds;
    });
  };

  return (
      <ModalForm
      config={{ url: Url.postProduct, method: params ? 'PUT' : 'POST' }}
      altApiCall={{ url: params ? Url.updateProductAlt : Url.postProductAlt, method: params ? "PUT" : "POST" }}
      title={`${ params ? 'Edit ' : 'Create ' }New Product` }
      description="Create a new product and link it to departments and categories."
    >
      {
        !isLoading ?
        <div className='flex justify-between'>
          <div className='w-3/5'>
            <div className='flex justify-between gap-6'>
              <CheckBoxToggle 
                label="Active" 
                defaultChecked={isActive} 
                onToggle={handleToggleActive}
              />
              <Input
                label="Active" 
                className='hidden'
                {...register("flActive", { value : isActive ? 1 : 0 })}
              />
            </div>
            <div className='flex justify-between gap-6'>
              <Input
                id='productname'
                defaultValue={params?.name || ''}
                label="Product Name"
                placeholder="Product Name"
                {...register('name', { required: true }) }
              />
              {params?.sku ?
                <Input
                  defaultValue={params.sku}
                  disabled
                  id='sku'
                  label="SKU"
                  placeholder="SKU"
                />
                :
                <Input
                  defaultValue={params?.sku || ''}
                  disabled={params?.sku ? true : false}
                  label="SKU"
                  placeholder="SKU"
                  {...register('sku', { required: true }) }
                />
              }
              </div>
              <Input
                defaultValue={params?.description || ''}
                label="Description"
                placeholder="Description"
                {...register('description', { required: false }) }
              />
              <Select
                defaultValue={params?.productTypeId?.toString() || ""}
                label="Product Type"
                options={productTypeOptions}
                placeholder='Select a product type...'
                {...register('productTypeId', { required: true, valueAsNumber: true })}
              />
              <div className='flex justify-between gap-6'>
                <Select
                  // disabled={params && currentClass ? false : !params ? false : true}
                  disabled={classLoading}
                  label="Class"
                  value={currentClass}
                  placeholder='Select a Class'
                  options={classOptions}
                  onChange={(e)=>handleClassChange(e.currentTarget.value)}
                />
                { subclassOptions.length > 0 ?
                  <Select
                    // disabled={currentClass ? false : !params ? false : true}
                    disabled={subClassLoading}
                    defaultValue={params?.subclassId?.toString()}
                    label="Sub Class"
                    placeholder='Select a Subclass...'
                    options={subclassOptions}
                    {...register('subclassId', { required: true, valueAsNumber: true })}
                  />
                  :
                  <Select
                      disabled
                      className='opacity-70'
                      label="Sub Class"
                      defaultValue={"placeholder"}
                      options={[{ value:"placeholder", children:"Loading..." }]}
                  />
                }
              </div>

              <div>
                <h3 className='font-semibold text-sm mb-1'>Select Traders</h3>
                <div className='bg-white px-3 py-2 shadow-sm border text-sm overflow-y-scroll max-h-32'>
                  <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1'>
                    {traders.map(trader => (
                      <label key={trader.traderId} className='flex items-center'>
                        <input
                    type="checkbox"
                    value={trader.traderId}
                    checked={selectedIds.includes(trader.traderId)} // Reflect selection from selectedIds
                    onChange={() => handleCheckboxChange(trader.traderId)} // Handle selection logic
                  />
                        <span className="ml-2">{trader.name}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

                {/* Price Level Fields */}
                <div>
                  <p className='text-lg font-bold mb-2 mt-4'>Price Levels</p>
                    <div className='flex gap-6'>
                      <CheckBoxToggle 
                        label="Open Price" 
                        defaultChecked={isActivePrice} 
                        onToggle={handleToggleOpenPrice}
                      />
                      <Input
                        label="Active" 
                        className='hidden'
                        {...register("flOpenPrice", { value : isActivePrice ? 1 : 0 })}
                      />
                      { !isActivePrice && !priceLoading ? 
                        <Input
                          defaultValue={currentPrice || ''}
                          type='number'
                          label="Unit Price"
                          step={0.01}
                          {...register('price', { required: false }) }
                        />
                        :
                        ''
                      }
                      { isActivePrice && !priceLoading ? 
                        <div className='flex gap-2 w-full'>
                          <Input
                            defaultValue={priceMin || ''}
                            type='number'
                            label="Min Price"
                            step={0.01}
                            {...register('openPriceMin', { required: false }) }
                          />
                          <Input
                            defaultValue={priceMax || ''}
                            type='number'
                            label="Max Price"
                            step={0.01}
                            {...register('openPriceMax', { required: false }) }
                          />
                        </div>
                        :
                      ''
                      }
                    { 
                      taxOptions.length > 0 && !taxLoading ?
                      <Select
                        defaultValue={TaxTypeData[0] && TaxTypeData[0]?.taxTypeId.toString()}
                        label="Tax"
                        placeholder='Select a Tax...'
                        options={taxOptions?.length > 0 ? taxOptions : [{ value: "", children: "..." }]}
                        {...register('taxTypeId', { required: true , valueAsNumber: true })}
                      /> 
                      :
                      <Select
                        disabled
                        className='opacity-70'
                        label="Tax"
                        defaultValue={"placeholder"}
                        options={[{ value:"loading", children:"Loading..." }]}
                      />
                    }
                  </div>
                </div>
                {/* END Price Level Fields */}
          </div>
          <div className='w-1/3'>
            <div className="flex flex-col text-left mb-0">
              <p className="font-semibold text-sm">
                Image
              </p>
              { imagePreview ? 
              <div className='w-full max-w-sm bg-gray-200 mt-2 flex items-center justify-center'>
                <img src={imagePreview ?? undefined} className="max-h-52 max-w-52 overflow-hidden" alt="" />
              </div>
              :
              <div className='h-48 text-sm text-gray-400 w-full max-w-sm bg-gray-200 mt-2 flex items-center justify-center'>
                Image Preview
              </div>
              }
              <div className='mt-7'>
                { buttonStyleOptions.length > 0 && currentButtonStyle ?
                  <Select
                    label="Button Style"
                    placeholder='Select a Button Style'
                    options={buttonStyleOptions}
                    value={currentButtonStyle}
                    onChange={(e)=>handleButtonChange(e.currentTarget.value)}
                  /> :
                  <Select
                    disabled
                    label="Button Style"
                    className='opacity-70'
                    defaultValue={"placeholder"}
                    options={[{ value:"loading", children:"Loading..." }]}
                  />
                }
              </div>
              
              {buttonStyleOptions.length > 0 && currentButtonStyle &&ButtonStyleOpt[0] && ButtonStyleOpt.map((option:any) => (
                option.buttonStyleId.toString() === currentButtonStyle && (
                  <ButtonStyleItem
                    key={option.buttonStyleId}
                    data={{
                      "buttonStyleId": option.buttonStyleId,
                      "name": option.name,
                      "foreground": option.foreground,
                      "borderstyle": option.borderstyle,
                      "text": option.text,
                      "flActive": true
                    }}
                  />
                )
              ))}
            </div>
          </div>
        </div>
        :
        <div className='flex items-center justify-center h-40'>
          <SpinnerIcon dark />
        </div>
      }
    </ModalForm>
  )
}

export default ProductAddPage
